import { FormEvent, useState } from "react";
import { KeyRound, LoaderCircle, LockKeyhole, UserRound } from "lucide-react";
import { login } from "../api";
import type { AccessContext } from "../types";

export function LoginScreen({ loading = false, onAuthenticated }: { loading?: boolean; onAuthenticated: (access: AccessContext) => void }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  async function submit(event: FormEvent) {
    event.preventDefault();
    setSubmitting(true);
    setError("");
    try {
      onAuthenticated(await login(username, password));
    } catch (caught) {
      setError(caught instanceof Error ? caught.message : "Не удалось войти");
    } finally {
      setSubmitting(false);
    }
  }

  return <main className="login-screen">
    <section className="login-card">
      <div className="login-brand"><span className="brand-mark">G</span><span><strong>Grafit</strong><em>OS</em></span></div>
      <div className="login-icon"><KeyRound size={23} /></div>
      <span className="eyebrow">Защищённый доступ</span>
      <h1>Вход в GrafitOS</h1>
      <p>Войдите под учётной записью администратора или сотрудника отдела продаж.</p>
      {loading ? <div className="login-loading"><LoaderCircle className="spin" size={20} />Проверка сессии</div> : <form onSubmit={submit}>
        <label><span>Логин</span><div><UserRound size={16} /><input autoFocus autoComplete="username" value={username} onChange={event => setUsername(event.target.value)} required /></div></label>
        <label><span>Пароль</span><div><LockKeyhole size={16} /><input type="password" autoComplete="current-password" value={password} onChange={event => setPassword(event.target.value)} required /></div></label>
        {error && <div className="login-error" role="alert">{error}</div>}
        <button type="submit" disabled={submitting}>{submitting ? <LoaderCircle className="spin" size={17} /> : <KeyRound size={17} />}{submitting ? "Вход..." : "Войти"}</button>
      </form>}
    </section>
  </main>;
}
